import yup from './yup'

export const isEditorContentEmpty = (html) => {
  const stripped = html
    .replace(/<(.|\n)*?>/g, '') // remove all HTML tags
    .replace(/&nbsp;/g, '') // remove non-breaking spaces
    .replace(/\s/g, '') // remove whitespace

  return stripped.length === 0
}

export const TemplateFormSchema = yup.object().shape({
  subject: yup.string().label('Subject').trimmedRequired('Email Subject is required'),
  body: yup
    .string()
    .label('Body')
    .trimmedRequired('Email Body is required')
    .test('is-not-empty', 'Email Body cannot be empty', (value) => !isEditorContentEmpty(value))
})
